export const editPublishedQuestModalOptions = {
   icon: 'warning',
   style: { width: 380 },
   message: (
      <>
         Señor usuario, está intentando editar un cuestionario publicado en el
         aplicativo Mundo Mutual. Si usted requiere editarlo se bajará la
         publicación.
         <div style={{ fontWeight: 200, marginTop: 20 }}>
            ¿Desea continuar con la opción de editar?
         </div>
      </>
   )
}
